import React, { useState } from "react"
import { toast } from 'react-toastify'

import Layout from "../../components/Layout"
import SEO from "../../components/seo"
import Header from "../../components/Header"
import Loading from "../../components/Loading"
import MessageBox from "../../components/MessageBox"
import ConfirmMobile from "../../components/me/ConfirmMobile"
import ChangePassModal from "../../components/me/ChangePassModal"
import NameFamilyModal from "../../components/me/NameFamilyModal"
import BrithdayModal from "../../components/me/BrithdayModal"
import NationalCodeModal from "../../components/me/NationalCodeModal"
import JobModal, { jobs } from "../../components/me/JobModal"

import Times from './../../images/icons/times.png'
import { apiCall, validateToken, getOfflineToken } from '../../../Helper'
import { useEffect } from "react"

import Avatar from './../../images//icons/avatar.png'
import Input from "../../components/Input"
import Inputt from "../../components/Inputt"
import Dropdown from "../../components/DropDown"

const legalItemRaw = {
  address: "", city: { id: 0, name: "", province: { id: 0, name: "" } }, editable: true,
  economical_code: "", id: 0, name: "", national_code: "", phone_number: "", postal_code: "",
  registration_code: "", submit_date: "", user: 0
}

export default () => {
  const user = getOfflineToken()

  const [isLoading, setIsLoading] = useState(false)

  const [dp] = useState('')

  const [name, setName] = useState(user.firstName || "")
  const [family, setFamily] = useState(user.lastName || "")
  const [email, setEmail] = useState(user.email || '')
  const [nationalCode, setNationalCode] = useState(user.nationalCode || '')
  const [foreign_code, setForeign_code] = useState(user.foreign_code || '')
  const [job, setJob] = useState(user.job ? jobs.find(x => x.id === user.job) : '')
  const [address, setAddress] = useState(user.address || '')
  const [birth_date, setbirth_date] = useState(user.birth_date);
  const [postal_code, setPostal_code] = useState(user.postal_code || "");
  const [iranian, setIranian] = useState(user.foreign_code ? false : true);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [legalInfo, setLegalInfo] = useState([]);
  const [selectedLegal, setSelectedLegal] = useState(0);

  // const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [codeSent, setCodeSent] = useState(false)

  const [selectedSession, setSelectedSession] = useState({})
  const [sessions, setSessions] = useState([])
  const [showMessageBox, setShowMessageBox] = useState(false)
  // const [showConfirmMobile, setShowConfirmMobile] = useState(false)


  // modal visibles
  const [showNameFamily, setShowNameFamily] = useState(false);
  const [showBrithday, setShowBrithday] = useState(false);
  const [showNationalCode, setShowNationalCode] = useState(false);
  const [showJob, setShowJob] = useState(false);
  const [showLegalBox, setShowLegalBox] = useState(false)

  function getSessions() {
    apiCall({
      url: '/user/userSessions',
    }).then(res => {
      if (res && res.data) {
        setSessions(res.data.others)
      } else toast.error('مشکل در سیستم')
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  function deleteSession() {
    setIsLoading(true)
    apiCall({
      url: '/user/userSessions',
      method: 'post',
      data: { token: selectedSession.token }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data && res.data.code === 0) {
        toast.success('حذف موفق')
        setShowMessageBox(false)
        getSessions()
      } else toast.error('مشکل در سیستم')
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  function updateInfo() {
    if (postal_code && postal_code.length !== 10) {
      return toast.error("کد پستی معتبر نیست")
    }

    if (!foreign_code && !nationalCode) return toast.error("کد ملی یا اتباع خارجی نمیتواند خالی باشد")
    if (!name || !family) return toast.error("نام و نام خانوادگی نمیتواند خالی باشد")
    if (!job.id) return toast.error("شغل نمیتواند خالی باشد")
    if (!address) return toast.error("آدرس نمیتواند خالی باشد")
    if (!birth_date) return toast.error("تاریخ تولد نمیتواند خالی باشد")

    setIsLoading(true)
    apiCall({
      url: '/user/manageNewInfo',
      method: 'post',
      data: {
        nationalCode: iranian ? nationalCode : "",
        foreign_code: !iranian ? foreign_code : "",
        firstName: name,
        lastName: family,
        email: email || undefined,
        job: job.id,
        address,
        birth_date,
        postal_code
      }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        if (res.data.code === 0) {
          toast.success('اطلاعات با موفقیت ویرایش شد')
          setTimeout(() => {
            apiCall({ url: '/user/userInfo' }).then(info => {
              typeof localStorage !== 'undefined' && localStorage.setItem("user", JSON.stringify({ token: getOfflineToken().token, ...info.data }))
              typeof window !== 'undefined' && window.location.reload()
            })
          }, 1000);
        } else toast.error(res.data.msg || 'مشکل در سیستم')
      } else toast.error('مشکل در سیستم')
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  function getToken() {
    if (confirmPassword.length < 4 || newPassword.length < 4) {
      return toast.error("طول رمز عبور نمیتواند کمتر از 4 رقم باشد")
    }
    if (confirmPassword === newPassword) {
      setIsLoading(true)
      apiCall({
        url: '/user/manageNewInfo',
      }).then(res => {
        setIsLoading(false)
        if (res && res.data) {
          if (res.data.code === 0 || res.data.code === 1) {
            setCodeSent(true)
            toast.success('کد تغییر رمز ارسال شد')
          } else toast.error(res.data.msg || 'مشکل در سیستم')
        } else toast.error('مشکل در سیستم')
      }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
    } else toast.error('رمز جدید با تایید رمز یکی نیست')
  }

  const getLegalInfo = () => apiCall({ url: '/user/manageLegalInfo' }).then((res) => {
    if (res.status === 200) {
      setLegalInfo(res.data)
    }
  })

  const getProvince = () => apiCall({ url: '/provinces' }).then((res) => setProvinces(res.data.map(({ id, name }) => ({ id, title: name }))))

  const getCites = async (province, index) => {
    const res = await apiCall({ url: '/cities', params: { province } })
    if (res && res.data) {
      const temp = [...cities];
      temp[index] = res.data.map(({ id, name }) => ({ id, title: name }));
      setCities(temp)
    }
  }

  const postLegalInfo = (data = legalItemRaw) => {
    if (!data.name) return toast.error("نام سازمان نمیتواند خالی باشد")
    if (!data.national_code) return toast.error("شناسه ملی نمیتواند خالی باشد")
    if (!data.registration_code) return toast.error("شناسه ثبت نمیتواند خالی باشد")
    if (!data.city_id) return toast.error("شهر محل دفتر مرکزی نمیتواند خالی باشد")
    if (!data.address) return toast.error("آدرس نمیتواند خالی باشد")

    apiCall({ url: '/user/manageLegalInfo', method: "post", data: { _id: data.id || undefined, ...data } }).then((res) => {
      if (res.data.code === 0) {
        toast.success("اطلاعات با موفقیت ذخیره شد")
        getLegalInfo()
      } else {
        toast.error(res.data.msg)
      }
    })
  }

  function deleteLegalInfo(_id) {
    setIsLoading(true)
    setShowLegalBox(false)
    apiCall({ url: '/user/manageLegalInfo', method: "delete", params: { _id } }).then((res) => {
      if (res?.data.code === 0) {
        getLegalInfo();
        toast.success("اطلاعات با موفقیت حذف شد")
      } else if (res?.data.code === 201) {
        toast.error("این سازمان دارای فاکتور میباشد")
      }
    }).finally(() => setIsLoading(false))
  }

  useEffect(() => {
    validateToken();
    getSessions();
    getLegalInfo();
    getProvince();
  }, [])

  const renderPasswordChange = () => {
    return <form className="bg-top-nav p-32"
      onSubmit={e => {
        e.preventDefault()
        getToken()
      }}>
      <h4 className="m-0 pr-16">مشخصات امنیتی</h4>
      <hr />
      <div className="grid mt-32 px-32" style={{ gap: 16 }}>
        {/*user.has_password && <Input dir="ltr" className="bg-light" type="password"
          placeholder="رمز عبور فعلی:" onChange={setOldPassword} value={oldPassword} />*/}
        <Input dir="ltr" className="bg-light" type="password"
          placeholder="رمز عبور جدید:" onChange={setNewPassword} value={newPassword} />
        <Input dir="ltr" className="bg-light" type="password"
          placeholder="تکرار رمز عبور:" onChange={setConfirmPassword} value={confirmPassword} />
      </div>

      <div className="pt-32 ltr">
        <button
          className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-tomato ml-16 py-5"
          style={{ width: 100, border: '1px solid var(--tomato)' }}>
          ثبت رمز جدید
        </button>
      </div>
    </form>
  }

  const renderSessions = () => {
    return <div className="bg-top-nav p-32">
      <h4 className="m-0 pr-16">نشست های فعال</h4>
      <hr />
      <div className="mt-32 px-32 overflow-auto" style={{ height: 158 }}>
        {
          sessions.map(session => (
            <React.Fragment key={session.token}>
              <div className="ltr flexed justify-between align-c">
                <div>
                  <h6 className="mt-0 mb-8">{session.agent}</h6>
                  <div className="font-9"><span>{session.ip}</span></div>
                  <div className="font-9"><span>{session.last_login}</span></div>
                </div>
                <div>
                  <button className="bd-none bg-none icon-button" onClick={() => { setSelectedSession(session); setShowMessageBox(true) }}>
                    <img src={Times} className="icon-sm" alt="" />
                  </button>
                </div>
              </div>
              <hr className="my-16" />
            </React.Fragment>
          ))
        }
      </div>
    </div>
  }

  const renderInformation = () => {
    return <div className={`bg-top-nav flexed`}>
      <div className="flexed fdir-col fl-c flex-2 bg-tomato-lighter">
        <div className="circle overflow-hidden mb-16 avatar">
          <img src={dp || Avatar} alt="" className="thumb-lg blocked" />
        </div>
        <span>{user.user_name}</span>
        {(user?.firstName || user?.lastName) &&
          <span className="font-10 text-tomato iran-sans-light">{user?.firstName + ' ' + user?.lastName}</span>}
      </div>
      <form className="flex-10 p-32"
        onSubmit={e => {
          e.preventDefault()
          updateInfo()
        }}>
        <h4 className="m-0 pr-16">مشخصات شخصی</h4>
        <hr />
        <div className="mt-32 px-32">
          <div className="grid" style={{ gridTemplateColumns: '4fr 4fr', gap: 16 }}>
            <Input className="bg-light" placeholder="نام و نام خانوادگی :"
              value={`${name} ${family}`} onFocus={() => setShowNameFamily(true)}
              type="text" inputStyle={{ cursor: "pointer" }} />
            <Input dir="ltr" className="bg-light" placeholder="کد ملی:" value={nationalCode || foreign_code}
              type="text" onFocus={() => setShowNationalCode(true)} inputStyle={{ cursor: "pointer" }} />
          </div>
          <div className="mt-16 grid" style={{ gridTemplateColumns: '4fr 4fr', gap: 16 }}>
            <Input dir="ltr" className="bg-light" placeholder="ایمیل:" onChange={setEmail} value={email} />
            <Input dir="ltr" value={birth_date} onChange={setbirth_date} className="bg-light" placeholder="تاریخ تولد:"
              onFocus={() => setShowBrithday(true)} type="text" inputStyle={{ cursor: "pointer" }} />
          </div>
          <div className="mt-16 grid" style={{ gridTemplateColumns: '4fr 4fr', gap: 16 }}>
            <Input dir="rtl" className="bg-light" placeholder="شغل:" value={job.title}
              onFocus={() => setShowJob(true)} inputStyle={{ cursor: "pointer" }} />
            <Input dir="ltr" className="bg-light" placeholder="آدرس:" value={address} onChange={setAddress} />
          </div>
          <div className="mt-16 mb-32 grid" style={{ gridTemplateColumns: '4fr 4fr', gap: 16 }}>
            <Inputt dir="ltr" className="bg-light" placeholder="کد پستی:" value={postal_code}
              onChange={(e) => e.target.value.length < 11 ? setPostal_code(e.target.value) : null} />
            <Input dir="ltr" className="bg-light" placeholder="موبایل:" value={user.mobile} disabled />
          </div>
        </div>

        <div className="pt-166 ltr">
          <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-tomato ml-16 py-5"
            style={{ width: 100, border: '1px solid var(--tomato)' }}>ثبت اطلاعات</button>
        </div>
      </form>
    </div>
  }

  const renderLegalInformation = ({ item = legalItemRaw, index = 0 }) => {
    function handleValueChanged(key, value) {
      const temp = [...legalInfo]
      temp[index][key] = value;
      setLegalInfo(temp)
    }

    const onRemove = () => {
      if (item.id) {
        setSelectedLegal(item.id)
        setShowLegalBox(true)
      } else {
        setLegalInfo(legalInfo.filter(x => x !== item))
      }
    };

    const onProvince = (e) => {
      const temp = [...legalInfo]
      const cityTemp = [...cities]
      temp[index].city.province = { ...e, name: e.title }
      temp[index].city = { ...item.city, name: "", id: 0 }
      cityTemp[index] = undefined
      setCities(cityTemp)
      setLegalInfo(temp)
    }

    const onCity = (e) => {
      const temp = [...legalInfo]
      temp[index].city_id = e.id
      temp[index].city = { ...item.city, ...e, name: e.title }
      setLegalInfo(temp)
    }

    return (<div className={`bg-top-nav flexed mt-32`} style={!item.editable ? { border: '1px solid var(--tomato)' } : {}}>
      <form className="flex-10 p-32"
        onSubmit={e => {
          e.preventDefault()
          item.editable && postLegalInfo({ ...item, city_id: item.city.id })
        }}>
        <h4 className="m-0 pr-16">مشخصات حقوقی</h4>
        <hr />
        <div className="mt-32 px-32">
          <div className="grid" style={{ gridTemplateColumns: '4fr 4fr', gap: 16 }}>
            <Inputt className="bg-light" placeholder="نام سازمان:" value={item.name} disabled={!item.editable}
              onChange={(e) => handleValueChanged("name", e.target.value)}
            />
            <Inputt dir="rtl" className="bg-light" placeholder="کد اقتصادی:" value={item.economical_code} disabled={!item.editable}
              type="number" onChange={(e) => e.target.value.length < 17 && handleValueChanged("economical_code", e.target.value)}
            />
          </div>
          <div className="mt-16 grid" style={{ gridTemplateColumns: '4fr 4fr', gap: 16 }}>
            <Inputt dir="rtl" className="bg-light" placeholder="شناسه ملی:" value={item.national_code} disabled={!item.editable}
              type="number" onChange={(e) => e.target.value.length < 11 && handleValueChanged("national_code", e.target.value)}
            />
            <Inputt dir="rtl" className="bg-light" placeholder="شناسه ثبت:" value={item.registration_code} disabled={!item.editable}
              type="number" onChange={(e) => e.target.value.length < 11 && handleValueChanged("registration_code", e.target.value)}
            />
          </div>
          <div className="mt-16 grid" style={{ gridTemplateColumns: '4fr 4fr', gap: 16 }}>
            <Dropdown btnClass="bg-light" items={provinces} selectedItem={{ ...item.city.province, title: item.city.province.name }}
              disabled={!item.editable} onItemClick={onProvince} name="استان محل دفتر مرکزی"
            />
            <Dropdown btnClass="bg-light" items={cities[index]} selectedItem={{ ...item.city, title: item.city.name }} disabled={!item.editable}
              onItemClick={onCity} name="شهر محل دفتر مرکزی" isOpen={(e) => e && !cities[index] && getCites(item.city.province.id, index)}
            />
          </div>
          <div className="mt-16 grid" style={{ gridTemplateColumns: '4fr 4fr', gap: 16 }}>
            <Inputt className="bg-light" placeholder="آدرس:" value={item.address}
              onChange={(e) => handleValueChanged("address", e.target.value)} disabled={!item.editable}
            />
            <Inputt className="bg-light" placeholder="کد پستی:" value={item.postal_code} disabled={!item.editable}
              type="number" onChange={(e) => e.target.value.length < 11 && handleValueChanged("postal_code", e.target.value)}
            />
          </div>
          <div className="mt-16 mb-32 grid" style={{ gridTemplateColumns: '4fr 4fr', gap: 16 }}>
            <Inputt lbl={"لطفا صفر اول وارد نکنید"} type="number" className="bg-light" placeholder="شماره تلفن ثابت:" value={item.phone_number}
              disabled={!item.editable} onChange={(e) => e.target.value.length < 11 && e.target.value.split("")[0] !== "0" && handleValueChanged("phone_number", e.target.value)}
            />
          </div>
        </div>
        <div className="pt-166 ltr">
          {item.editable ? <><button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-tomato ml-16 py-5"
            style={{ width: 100, border: '1px solid var(--tomato)' }}>ثبت اطلاعات</button>
            {item.id ? <button className="bd-none bg-none iran-sans radius-4 font-10 text-tomato ml-16 py-5"
              style={{ width: 100 }} type="button" onClick={onRemove}>حذف</button> : null}</>
            : <span className="font-10" style={{ color: 'var(--tomato)' }}>به دلیل وجود فاکتور با این مشخصات امکان حذف وجود ندارد</span>}
        </div>
      </form>
    </div>)
  }

  return (
    <div className="slideInTop">
      <SEO title="پروفایل کاربری" />
      <Header />
      <Layout className="p-32">
        <h3 className="m-0 text-shadow font-16 pr-16">پروفایل</h3>
        <hr className="mb-0" />
        <div className="px-32 pt-45 grid slideInTop">
          {/* user info */}
          {renderInformation()}
          <div className="grid mt-45" style={{ gridTemplateColumns: '1fr 1fr', gap: 45 }}>
            {renderPasswordChange()}
            {renderSessions()}
          </div>
          <div>
            {legalInfo.map((item, index) => renderLegalInformation({ item, index }))}
            <button className="bd-none bg-none icon-button iran-sans radius-4 text-tomato ml-16 py-5 mt-32"
              style={{ width: 200, border: '1px solid var(--tomato)' }}
              disabled={legalInfo[legalInfo.length - 1]?.id || legalInfo.length === 0 ? false : true}
              onClick={() => setLegalInfo([...legalInfo, legalItemRaw])}>افزودن اطلاعات حقوقی</button>
          </div>
        </div>

        <ChangePassModal
          setIsLoading={setIsLoading}
          newPassword={newPassword}
          show={codeSent} toggleShow={setCodeSent}
          full
        />
        <NameFamilyModal
          setIsLoading={setIsLoading}
          name={user.firstName}
          family={user.lastName}
          setNameFamily={(e) => { setName(e.name); setFamily(e.family) }}
          show={showNameFamily} toggleShow={setShowNameFamily}
        />
        <BrithdayModal show={showBrithday} toggleShow={setShowBrithday} onSubmit={(e) => setbirth_date(e)} value={birth_date} />
        <NationalCodeModal show={showNationalCode} toggleShow={setShowNationalCode}
          onSubmit={(e) => {
            setIranian(e.iranian)
            if (e.iranian) {
              setNationalCode(e.nationalCode)
              setForeign_code("")
            } else {
              setForeign_code(e.foreign_code)
              setNationalCode("")
            }
          }} value={{ nationalCode, foreign_code }} iraninan={foreign_code ? false : true} />
        <JobModal show={showJob} toggleShow={setShowJob}
          onSubmit={(e) => setJob(e)} value={job} />

        {/* <DeleteModal show={showDelete} toggleShow={setShowDelete}
          onSubmit={() => { }} /> */}

        <ConfirmMobile setIsLoading={setIsLoading} updateInfo={updateInfo} full />
        <Loading show={isLoading} full />
        <MessageBox show={showMessageBox} toggleShow={setShowMessageBox} full title="تایید حذف"
          description="آیا از حذف آیتم مطمئن هستید؟" onAccept={deleteSession} />
        <MessageBox show={showLegalBox} toggleShow={setShowLegalBox} full title="تایید حذف"
          description="آیا از حذف آیتم مطمئن هستید؟" onAccept={() => deleteLegalInfo(selectedLegal)} />
      </Layout>
    </div>
  )
}
